// extracted by mini-css-extract-plugin
module.exports = {"component":"Form_component__cZaXB"};